<div class="bg-white pb-3 text-xs">

  <mat-form-field [formGroup]="form" appearance="outline" class="rounded-xl pl-3 pr-3 w-full" hideRequiredMarker>
    <mat-label>{{'labels.search' | translate | titlecase}}</mat-label>
    <div matPrefix class="tk-i-search-black w-4 h-4 mr-2"></div>
    <input id="input-filter" matInput class="" type="text" formControlName="search" autocomplete="false" maxlength="25">
  </mat-form-field>

  <div class="flex items-center ml-3 font-semibold">

    <div id="btn-all" (click)="onFilterSelected(FilterType.All)" class="mr-2 rounded-md bg-transparent cursor-pointer"
         [ngClass]="{'tk-border-blue': isFilterSelected(FilterType.All),'tk-border-gray-2': !isFilterSelected(FilterType.All)}">
      <div class="px-2 py-1">{{'labels.all' | translate | titlecase}}</div>
    </div>

    <div id="btn-available" (click)="onFilterSelected(FilterType.Available)" class="mr-2 rounded-md bg-transparent cursor-pointer"
         [ngClass]="{'tk-border-blue': isFilterSelected(FilterType.Available),'tk-border-gray-2': !isFilterSelected(FilterType.Available)}">
      <div class="px-2 py-1">{{'handover.filter-available' | translate | titlecase}}</div>
    </div>

    <div id="btn-given" (click)="onFilterSelected(FilterType.Given)" class="mr-4 rounded-md bg-transparent cursor-pointer"
         [ngClass]="{'tk-border-blue': isFilterSelected(FilterType.Given),'tk-border-gray-2': !isFilterSelected(FilterType.Given)}">
      <div class="px-2 py-1">{{'handover.filter-given' | translate | titlecase}}</div>
    </div>

    <div class="tk-c-blue cursor-pointer font-normal" (click)="onClean()">{{'labels.clear' | translate | titlecase}}</div>

  </div>
</div>


